import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Flex, Heading, Button, Text, useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import {
  primary,
  white,
  textSecondary,
  textPrimary,
  buttonRed,
  buttonRedText,
  primaryAlt,
  color6,
} from "../../../utils/colors";
import { updateTenantOnboardingStatusAction } from "../../../actions/tenantActions";
import { TENANT_UPDATE_ONBOARDING_STATUS_RESET } from "../../../constants/tenantConstants";
import { listTenantDetails } from "../../../actions/tenantActions";

const OnboardingStepSkip = ({
  lastStep,
  prev,
  next,
  onClose,
  setStep,
  setStepSkip,
}) => {
  const { t } = useTranslation();
  const toast = useToast();

  // STATE
  const [email, setEmail] = useState("");

  // REDUX
  const dispatch = useDispatch();

  const tenantUpdateOnboardingStatus = useSelector(
    (state) => state.tenantUpdateOnboardingStatus
  );
  const {
    loading: loadingUpdateOnboardingStatus,
    success: successUpdateOnboardingStatus,
    error: errorUpdateOnboardingStatus,
  } = tenantUpdateOnboardingStatus;

  // HANDLERS
  const handleQuit = () => {
    dispatch(updateTenantOnboardingStatusAction("skipped"));
  };

  const handleContinue = () => {
    setStep(lastStep);
    setStepSkip(false);
  };

  // USE EFFECT
  //   useEffect(() => {
  //     if (successUpdateOnboardingStatus) {
  //       setStep(1);
  //       setStepSkip(false);
  //       onClose(); // This will handle the logic to close the modal or finish the process

  //       dispatch({ type: TENANT_UPDATE_ONBOARDING_STATUS_RESET });
  //     } else if (errorUpdateOnboardingStatus) {
  //       toast({
  //         title: t("toasts.updateTenantOnboardingStatusError"),
  //         status: "error",
  //         duration: 5000,
  //         isClosable: true,
  //       });

  //       dispatch({ type: TENANT_UPDATE_ONBOARDING_STATUS_RESET });
  //     }
  //   }, [successUpdateOnboardingStatus, errorUpdateOnboardingStatus]);

  useEffect(() => {
    if (successUpdateOnboardingStatus) {
      dispatch({ type: TENANT_UPDATE_ONBOARDING_STATUS_RESET });
      dispatch(listTenantDetails()); // ✅ Fetch updated details
      setStep(1);
      setStepSkip(false);
      onClose(); // Close the modal
    } else if (errorUpdateOnboardingStatus) {
      toast({
        title: t("toasts.updateTenantOnboardingStatusError"),
        status: "error",
        duration: 5000,
        isClosable: true,
      });

      dispatch({ type: TENANT_UPDATE_ONBOARDING_STATUS_RESET });
    }
  }, [successUpdateOnboardingStatus, errorUpdateOnboardingStatus, dispatch]);

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      p="4rem"
      maxW="800px"
    >
      {/* <Text fontSize="3rem">🎉</Text> */}

      <Heading as="h2" fontSize="3rem" textAlign="center" maxW="80%">
        {t("onboarding.questionSkip")}
      </Heading>

      <Text
        fontSize="1rem"
        fontWeight="500"
        textAlign="center"
        color={textSecondary}
        maxW="80%"
        m="1rem 0 0"
      >
        {t("onboarding.questionSkipText")}
      </Text>

      <Flex align="center" justify="center" w="100%" gap={4} m="2rem 0 0">
        <Button
          h="3.5rem"
          size="lg"
          fontSize="md"
          borderRadius="10rem"
          onClick={handleQuit}
          bg={buttonRed}
          color={buttonRedText}
          px="3rem"
          _hover={{
            bg: color6,
            color: white,
          }}
        >
          {t("onboarding.skipOnboarding")}
        </Button>
        <Button
          h="3.5rem"
          size="lg"
          fontSize="md"
          borderRadius="10rem"
          onClick={handleContinue}
          bg={textPrimary}
          border={`0px solid ${primary}`}
          color={white}
          px="2rem"
          transition="all 0.3s ease"
          _hover={{
            bg: primaryAlt,
            color: white,
            opacity: "0.8",
          }}
        >
          {t("onboarding.continueOnboarding")}
        </Button>
      </Flex>
    </Flex>
  );
};

export default OnboardingStepSkip;
